import React from "react";
import { useTranslation } from "react-i18next";
import { useResponsive } from "../../hooks/useResponsive";
import AddToCartBtn from "../detail/AddToCartBtn";
import { PriceDetailSummary } from "./PriceRowArea";
import { UiSubTitle } from "../text/UiTitle";
import BookingCardBody from "./BookingCardBody";
import { useBookingCard } from "./useBookingCard";
import { useSearchParamsOfBooking } from "../../hooks/searchParams/useSearchParamsOfBooking";
const BookingCard: React.FC = () => {
  const { t } = useTranslation();
  const { editBookingId, isEdit, isUpgrade } = useSearchParamsOfBooking();
  const useBookingCardProps = useBookingCard({
    editBookingId,
    isEdit,
    isUpgrade,
  });
  const responsive = useResponsive();
  if (!responsive.isDesktop) return null;
  return (
    <div className="w-[23rem] rounded-[1.25rem] border border-[#DEDEDE] p-5">
      <div className="mb-5 flex justify-between">
        <UiSubTitle text={t("Your option")} />
        {!isEdit && !isUpgrade && (
          <button
            onClick={() => useBookingCardProps.onReset()}
            className="text-[0.875rem] font-normal leading-[1.375rem] text-[#007AFF]"
          >
            {t("Reset")}
          </button>
        )}
      </div>
      <BookingCardBody useBookingCardProps={useBookingCardProps} />
      <div className="pb-5">
        <PriceDetailSummary useBookingCardProps={useBookingCardProps} />
      </div>
      <AddToCartBtn useBookingCardProps={useBookingCardProps} />
    </div>
  );
};

export default BookingCard;
